import { InjectProperty, Injectable } from '@jack-henry/frontend-utils/di';
import { AchExceptionsDecisionsActivityRequestModelDto } from '@treasury/api/channel';
import { PositivePayService } from '@treasury/domain/channel/services/positive-pay/positive-pay-service';
import type {
    GridDataProviderCallback,
    GridDataProviderParams,
    GridSorterDefinition,
} from '@vaadin/grid';

@Injectable()
export default class AchExceptionsActivityDataProvider {
    @InjectProperty()
    declare private positivePayService: PositivePayService;

    public async achExceptionsActivityDataProvider(
        params: GridDataProviderParams<AchExceptionsDecisionsActivityRequestModelDto>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        callback: GridDataProviderCallback<any>
    ) {
        const { page, pageSize, sortOrders } = params;

        const { achExceptionDecisions, count } =
            await this.positivePayService.searchPaginatedAchExceptionsActivity({
                ...params,
                pagingParameters: {
                    pageSize,
                    pageNumber: page,
                    orderBys: sortOrders.map((sorter: GridSorterDefinition) => ({
                        name: sorter.path,
                        descending: sorter.direction === 'desc',
                    })),
                },
                searchText: '',
                searchAccountNickname: true,
                previousBusinessDayCutoff: '',
                currentBusinessDayCutoff: '',
            });

        callback(achExceptionDecisions || [], count);
    }
}
